var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPremiumCurved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 164,
    viewBox: "0 0 310 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V164C134 104 259.919 140.73 310 164V0H0Z",
    fill: "url(#paint0_linear_385_6672)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_385_6672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.236 34.1784C278.062 34.1784 273.057 39.183 273.057 45.3529C273.057 39.1792 268.053 34.1784 261.883 34.1784C268.057 34.1784 273.057 29.1737 273.057 23C273.057 29.1737 278.062 34.1784 284.236 34.1784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.941 50.6482C265.367 50.6482 262.469 53.5456 262.469 57.1177C262.469 53.5434 259.572 50.6482 256 50.6482C259.574 50.6482 262.469 47.7508 262.469 44.1765C262.469 47.7508 265.367 50.6482 268.941 50.6482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.412 56.5305C281.838 56.5305 278.94 59.4279 278.94 63C278.94 59.4257 276.043 56.5305 272.471 56.5305C276.045 56.5305 278.94 53.6331 278.94 50.0588C278.94 53.6331 281.838 56.5305 285.412 56.5305Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_385_6672",
    x: 256,
    y: 23,
    width: 34.4121,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_385_6672"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_385_6672",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_385_6672",
    x1: 155,
    y1: 0,
    x2: 155.306,
    y2: 137.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A72E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3855E2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumCurved);
export default __webpack_public_path__ + "static/media/premiumCurved.1350d1ce9fec23f0fdae03e1ed018ad4.svg";
export { ForwardRef as ReactComponent };